import { Link } from 'react-router-dom';
import '../../css/AccountPages.css';

export default function AccountIntro({ eyebrow = 'Area agenzie', title, children, backTo = '/', backLabel = 'Torna alla home' }) {
    return (
        <div className="ef-account-intro">
            <Link className="ef-account-back" to={backTo}><span aria-hidden="true">←</span> {backLabel}</Link>
            <p className="ef-account-eyebrow">{eyebrow}</p>
            <h1>{title}</h1>
            <p className="ef-account-intro__description">{children}</p>
        </div>
    );
}
